import { ofType } from "redux-observable";
import { ajax } from "rxjs/ajax";
import { map, switchMap, catchError } from "rxjs/operators";

import {
  FETCH_ORGANIZATION_BY_ID,
  FETCH_ORGANIZATION_BY_ID_SUCCESS,
  FETCH_ORGANIZATION_BY_ID_FAIL,
} from "../../constants";

const fetchOrganizationById = (action$, state$) =>
  action$.pipe(
    ofType(FETCH_ORGANIZATION_BY_ID),
    switchMap((action) => {
      const fullUrl = `${state$.value.auth.server}/admin/organizations/${action.organizationId}`;
      console.log('Fetching Organization by ID from:', fullUrl);

      return ajax({
        url: fullUrl,
        headers: {
          Authorization: `Bearer ${state$.value.auth.LIPToken}`,
        },
        responseType: "json",
        crossDomain: true,
        method: "GET",
      }).pipe(
        map((response) => {
          console.log('Organization by ID API Response:', response);
          return {
            type: FETCH_ORGANIZATION_BY_ID_SUCCESS,
            data: response.response,
          };
        }),
        catchError((error) => {
          console.error('Organization by ID API Error:', error);
          return [{
            type: FETCH_ORGANIZATION_BY_ID_FAIL,
            error: error
          }];
        })
      );
    }),
  );

export default fetchOrganizationById;

